<template>
	<div class="layout-column">
		<div class="date-picker" ref="parent">
			<div class="layout-column">
				<label class="label">{{dateLabel}}</label>
				<v-button class="date-selector" border @click="toggle()" ref="start_date">
					<div class="flex layout-row flex-center">
						<inline-svg class="margin-r-10" :src="require('@/assets/img/date.svg')" />
						{{currentDateRange}}
					</div>
				</v-button>
			</div>

			<div class="layout-column">
				<label class="label">{{timeLabel}}</label>

				<v-button :name="'range_picker_range_trigger-'+id" border class="date-selector" ref="dropdown" @click="tippyDropdown.show()" >
					<div class="flex layout-row flex-center">
						<inline-svg class="margin-r-10" :src="require('@/assets/img/clock-outline.svg')"/>
						<span>{{currentTimeFormat}}</span>
					</div>
				</v-button>

				<tippy :to="'range_picker_range_trigger-'+id" :ref="'tippy-'+id"
				       theme="transparent" placement="bottom" trigger="manual" hideOnClick interactive interactiveBorder="0">
					<div class="mainleft_new_step_dropdown range-picker-dropdown" >
						<ul>
							<li v-for="t in times" :key="t">
								<a @click="selectTime(t)">
									{{t}}
								</a>
							</li>
						</ul>
					</div>
				</tippy>
			</div>
		</div>
		<div class="container" ref="container"></div>

	</div>
</template>

<script>
import Litepicker from 'litepicker';
import VButton from "@/components/base/v-button";
import TimezonePopup from "@/components/popups/timezone-popup";

let id = 1;
const moment = require('moment-timezone');

export default {
	name: "date-picker",
	components: {TimezonePopup, VButton},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {

		dateLabel:{
			default: 'Date'
		},
		value:{
			default: () => moment(),
		},
		timeLabel:{
			default: 'Time'
		},
		hasTime:{
			type: Boolean,
			default: true,
		},
		minDate:{
			default: null,
		},
		maxDate:{
			default: null,
		},
	},

	data(){
		return {
			id: id++,
			tippyDropdown: false,
			dropdownOpen: false,

			currentDate: moment(this.value||''),
			picker: null,
			shown: false,
			times: [],
		}
	},
	watch:{
		value(val,oldVal){
			this.currentDate = moment(this.value||'')
		}
	},
	computed: {
		currentDateRange() {
			let start = moment(this.currentDate);
			start = start.format("DD MMM yyyy");
			return start;
		},
		currentTimeFormat() {
			let start = moment(this.currentDate)
			let t = start.format("HH:mm");
			return t;
		},
	},
	methods: {
		selectTime(t){
			let p = t.split(':')
			let start = moment(this.currentDate);
			let newTime = start.clone().set({'day':start.get('day'),
				'month':start.get('month'),'year':start.get('year'),
				'hour':p[0],
				'minute':p[1],
			}) //.set('yyyy-MM-DD HH:mm', start.format('yyyy-MM-DD') + ' ' + t)
			this.currentDate = newTime;
			this.tippyDropdown.hide()
			this.onDateChanged()
		},
		onDateChanged() {
			let d = this.currentDate;
			// if (d) d = d.utc(true)
			this.$emit('change', d);
		},
		setupPickers() {
			if (this.picker)
				this.picker.destroy();

			this.picker = new Litepicker({
				startDate: this.currentDate,
				endDate: this.currentDate,
				minDate: this.minDate,
				maxDate: this.maxDate,
				minDays: 1,
				// maxDays: 1,
				allowRepick: true,

				parentEl: this.$refs.container,
				inlineMode: false,
				format: 'D MMM, YYYY',
				numberOfMonths: 1,
				numberOfColumns: 1,
				singleMode: true,
				// autoApply: true,
				mobileFriendly: false,
				lang: "en-US",
				element: this.$refs.start_date,
				moveByOneMonth: true,
				// elementEnd: this.$refs.start_date,
				onShow: () => { this.shown = true; },
				onHide: () => { this.shown = false;},
				onSelect: (date1) => {

					let t = moment(this.currentDate).format('HH:mm');
					let newTime = moment(moment(date1).format('yyyy-MM-DD') + ' ' + t, 'yyyy-MM-DD HH:mm')

					this.currentDate = newTime;
					this.onDateChanged();
					// if (this.shown) this.picker.hide()
				}
			});

		},
		toggle() {
			try {
				if (this.shown)
					this.picker.hide()
				else {
					this.shown = true;//
					if (this.picker) {
						this.picker.destroy();
					}
					this.setupPickers(); // resetup picker in case dates changed.
					this.picker.show();
				}
			}catch (e) {

			}
		}
	},
	created() {
		for (let i = 0; i <= 23; i++) {
			this.times.push(`${String(i).padStart(2, '0')}:00`)
			this.times.push(`${String(i).padStart(2, '0')}:30`)
		}
	},
	mounted() {
		this.currentDate = moment(this.value||'');
		this.tippyDropdown = this.$refs['tippy-'+this.id].tippy();
		this.setupPickers();
	},
}
</script>

<style lang="scss" scoped>
.date-picker {
	//position: relative;
	display: flex;
	flex-direction: row;
	gap: 60px;

	.button {
		border-radius: 6px 0 0 6px;
		display: flex;
		padding: 3px 15px;
		min-width: 200px;
		color: $darker-grey;
		background: #FFFFFF;
		border: 1px solid #e3e6f1;

		&:hover {
			color: $blue;
			border-color: $blue;
			svg {
				fill: $blue;
			}
		}
		&.date-selector {
			border-radius: 6px;

			svg {
				width: 22px;
				height: 22px;
			}
		}
		svg {
			display: flex;
			position: relative;
			fill: $darker-grey;

		}
	}
}
</style>

<style lang="scss">
.range-picker-dropdown {
	min-width: 200px;
	max-height: 300px;
	overflow: hidden;
	overflow-y: auto;
	padding: 0;
	border-radius: 6px;
}
.litepicker .month-item-header {
	font-size: 13px;
}
.litepicker .container__months .month-item:last-child .button-next-month {
	cursor: pointer;
}
.litepicker .container__months .month-item:first-child .button-previous-month {
	cursor: pointer;
}
.litepicker .container__days .day-item {

	&:hover {
		color: $blue;
		box-shadow: inset 0 0 0 1px $blue;
	}
	&.is-in-range {
		background-color: #e2eaf5;
	}
	&.is-end-date, &.is-start-date {
		background-color: $blue;
		color: white;
		&:hover {
			color: white;
		}
	}
	&:hover {
		color: $blue;
	}
}
.litepicker .container__days>div, .litepicker .container__days>a {
	padding: 10px 0;
}


</style>
